<template>
  <div class="log">
    <div class="email" @click="searchByUser">{{ data.email }}</div>
    <div class="plan">{{ data.plan }}</div>
    <div class="date">{{ getDate }}</div>
  </div>
</template>

<script>
export default {
  name: 'UserRow',
  props: {
    data: Object
  },
  methods: {
    searchByUser() {
      this.$emit('searchByUser', this.data.email);
    }
  },
  computed: {
    getDate() {
      const date = new Date(this.data.lastActivity);
      let day = date.getDate();
      if(day < 10) {
        day = '0' + day;
      }
      let month = date.getMonth() + 1;
      if(month < 10) {
        month = '0' + month;
      }
      let year = date.getFullYear();

      let hour = date.getHours();
      if(hour < 10) {
        hour = '0' + hour;
      }
      let minutes = date.getMinutes();
      if(minutes < 10) {
        minutes = '0' + minutes;
      }

      let formated = `${day}/${month}/${year} - ${hour}:${minutes}`
      return formated;
    },
    getMeta() {
      if(this.data.metadata) {
        return this.data.metadata[Object.keys(this.data.metadata)[0]];
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.log {
  width: 90%;
  height: 3.5rem;
  background-color: rgb(224, 224, 224);
  margin-bottom: 1rem;
  border-radius: 0.2rem;
  display: flex;

  .email {
    flex: 1;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-weight: bold;
    padding-left: 2rem;
    @media (max-width: 600px) {
      padding-left: 1rem;
    }
    @media (max-width: 400px) {
      font-size: 0.9rem;
      padding-left: 0.8rem;
    }

    transition: 0.2s;
    &:hover {
      color: #11b6a6;
      cursor: pointer;
    }
  }

  .plan {
    flex: 1;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-style: italic;
    @media (max-width: 900px) {
      flex: 0.5;
    }
    @media (max-width: 700px) {
      flex: 0.3;
    }
    @media (max-width: 400px) {
      font-size: 0.9rem;
    }
  }

  .date {
    flex: 1;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 700px) {
      flex: 0.7;
    }
    @media (max-width: 600px) {
      display: none;
    }
  }
}
</style>